import(/* webpackChunkName: "whatYourLotWin" */ '../Styles/whatYourLotWin.scss');

class WhatYourLotWin {
    constructor() {
        this.WhatYouLotTypeClass = '.what-your-lot-type';
        this.WhatYoutLotTypeSelectType = '.what-your-lot-type__select';
        this.TabElementClass = '.tabs__tabelement';
        this.TabClass = '.tabs__tab';
        this.resizedFinished = false;
    }

    hideAllTabs(parent) {
        parent.querySelectorAll(this.TabElementClass).forEach(tab => tab.hidden = true);
    }

    init() {
        if (document.querySelector(`${this.WhatYouLotTypeClass}--in-editor`) || !document.querySelector(this.WhatYouLotTypeClass)) {
            return;
        }

        document.querySelectorAll(this.WhatYouLotTypeClass).forEach(parent => {
            parent.querySelectorAll(this.TabClass).forEach(tab => {
                tab.addEventListener('click', (event) => {
                    parent.querySelector(this.WhatYoutLotTypeSelectType).value = tab.id;
                });
            });

            parent.querySelector(this.WhatYoutLotTypeSelectType).addEventListener("change", (event) => {
                if (event.currentTarget.value) {
                    document.getElementById(event.currentTarget.value).click();
                } else {
                    this.hideAllTabs(parent);
                }
            });
        });

        const setup = (tag) => {
            if (tag.matches) { // mobile
                document.querySelectorAll(this.WhatYouLotTypeClass).forEach(tag => {
                    const selectedValue = tag.querySelector(this.WhatYoutLotTypeSelectType).value;
                    if (selectedValue) {
                        document.getElementById(selectedValue).click();
                    } else {
                        this.hideAllTabs(tag);
                    }   
                });
            } else {
                document.querySelectorAll(this.WhatYouLotTypeClass).forEach(tag => {
                    const selectedValue = tag.querySelector(this.WhatYoutLotTypeSelectType).value;
                    if (selectedValue) {
                        document.getElementById(selectedValue).click();
                    } else {
                        tag.querySelectorAll(this.TabClass)[0].click();
                    }
                });
            }
        }

        const mediaQuery = window.matchMedia("(max-width: 767px)");
        setup(mediaQuery) // Call listener function at run time
        mediaQuery.addListener(setup) // Attach listener function on state changes
    }
}

const whatYourLotWin = new WhatYourLotWin();
whatYourLotWin.init(); 